import gmic from "./images/gmic_chaos/t.png"
import fiddle from "./images/fiddles/t.png"

import fiddleGIF from "./images/fiddle_gif.gif"

import bit from "./images/bitcrush.PNG"
import sammel from "./images/karten.png"
import pattern from "./images/pattern.png"
import p5 from "./images/bg.gif"
import wolle from "./images/wolle.gif"


// eslint-disable-next-line import/no-anonymous-default-export
export default {

  projects: [
    {
      title: "Bitcrushi",
      para:
        "A vst-plugin written in C++ that can be used to create a bitcrush effect.",

      imageSrc:
        bit,
      url: "https://github.com/hx-ux/Bitcrushi",
    },
    {
      title: "Sammelkarten",
      para:
        "Create randomised images using the Gmic library.",
      imageSrc:
        sammel,
      url: "/sammelkarten",
    },



    {
      title: "Pattern Chan",
      para:
        "Create beautiful SVG-Patterns",

      imageSrc:
        pattern,

      url: "https://patternchan.netlify.app/",
    },


  ],

  artwork: [
    {
      title: "Gmic Chaos",
      para:
        "enter the void",
      imageSrc:
      wolle,
      url: "/gmicchaos",
    },
    {
      title: "Line Fiddles",
      para:
        "just lines",
      imageSrc:
      fiddleGIF,
      url: "/fiddle",
    },

    {
      title: "GELBER SACK",
      para:
        "it is what it is ",
      imageSrc:
        p5,
      url: "/p5",
    },

  ],

}

